module.exports = __webpack_public_path__ + "img/teacher1_yijian.59e1e101.png";